import { Select, SelectOption } from '@veneer/core';
import React, { ReactNode, useState, useRef } from 'react';
import '../../../assets/css/views/activations/customButton.css';

interface SelectWrapperProps {
    children?: ReactNode;
    options: SelectOption[];
    onChange: (newValue: any) => void;
    onClear: () => void;
    value: any;
    disabled: boolean;
    label: string;
    style?: React.CSSProperties;
    onOpen?: () => void;
    onClose?: () => void;
    [key: string]: any;
}

const SelectWrapper: React.FC<SelectWrapperProps> = ({
    children,
    options,
    onChange,
    onClear,
    value,
    disabled,
    label,
    style,
    onOpen,
    onClose,
    ...props
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef<HTMLDivElement | null>(null);

    const handleSelectClick = () => {
        setIsOpen(true);
        if (!disabled && onOpen) {
            onOpen();
        }
    };

    const handleSelectClose = () => {
        if (!disabled && onClose && !onOpen) {
            onClose();
        }
        setIsOpen(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
            handleSelectClose();
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="activationSelect" style={style} ref={selectRef}>
            {children}
            <div onClick={handleSelectClick}>
                <Select
                    options={options}
                    id="select-SubRetail"
                    label={label}
                    placement="bottom"
                    helperTextVisibility="auto"
                    onChange={onChange}
                    onClear={onClear}
                    value={value}
                    disabled={disabled}
                    multiple
                    {...props}
                />
            </div>
        </div>
    );
};

export default SelectWrapper;
